import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Routing } from 'global/routing';
import { Store } from 'store';
import { externalOAuthSignInErrorMessage } from './external-oauth-sign-in-error';

export function useExternalOAuthCallback(
  search: string,
  login: (params: { authorizationCode: string }) => void
): void {
  const history = useHistory();
  const { showNotification } = Store.useNotifications();
  const intl = useIntl();

  useEffect(() => {
    const code = new URLSearchParams(search).get('code');

    if (code) {
      login({ authorizationCode: code });
      return;
    }

    showNotification({
      variant: 'error',
      description: intl.formatMessage(externalOAuthSignInErrorMessage),
      dismissible: true,
    });
    history.push(Routing.LOGIN.getPath());
  }, [search]);
}
